import { observable, action } from "mobx";
import agent from "../agent";
import { $util, $const } from "../helper";

class AuthStore {
  @observable inProgress = false;
  @observable errors = undefined;
  @observable userIsOk = false;
  @observable userWorkIsOk = false;
  @observable educations = [];
  @observable userNotice = false;
  @observable userWorkNotice = false;
  @observable joinOrCreateModal = false;
  @observable messages = [];
  @observable hasUnReadMessage = false;
  @observable joinGameTitle = "";
  @observable joinGameId = undefined;
  // 论坛已有的队伍列表
  @observable bbsTeamList = [];
  // 论坛已有队伍中，是否在任意一个队伍有管理权限
  @observable bbsHasTeamManagement = false;
  // 论坛已有的队伍且有管理权限的（队长or领队老师）
  @observable bbsTeamWithManagement = [];

  @observable user = {};
  @observable workInfo = {};

  @observable oldUser = true;

  @action pullUser() {
    return Promise.all([
      agent.Auth.current(),
      agent.Auth.getEducations(),
      agent.Auth.getWorkInfo(),
      agent.BbsPlatform.getBBSTeamList()
    ]).then(
      action(res => {
        this.user = res[0].member;
        this.workInfos = res[2].occupations;
        this.bbsTeamList = res[3] && res[3].data;
        this.bbsTeamWithManagement =
          res[3] &&
          res[3].data &&
          res[3] &&
          res[3].data.filter(item =>
            $const.BBS_TEAM_POSITION_WITH_MANAGEMENT.includes(item.position)
          );
        this.bbsHasTeamManagement = !!(
          this.bbsTeamWithManagement && this.bbsTeamWithManagement.length > 0
        );
        this.userIsOk = this.checkUer(this.user);
        this.userWorkIsOk = this.checkUerWork(this.workInfos);
        // this.oldUserNeedVaild = this.oldUser && this.user && !this.user["contact_email"];
      })
    );
  }

  @action updateBBSTeamInfo() {
    return agent.BbsPlatform.getBBSTeamList().then(
      action(res => {
        this.bbsTeamList = res && res.data;
        this.bbsTeamWithManagement =
          res &&
          res.data &&
          res &&
          res.data.filter(item => $const.BBS_TEAM_POSITION_WITH_MANAGEMENT.includes(item.position));
        this.bbsHasTeamManagement = !!(
          this.bbsTeamWithManagement && this.bbsTeamWithManagement.length > 0
        );
      })
    );
  }

  @action getMessages(status) {
    return agent.Common.getMessages(status).then(
      action(res => {
        this.messages = res.messages || [];
        let slug = false;
        this.messages &&
          this.messages.forEach(message => {
            if (message.status !== $const.MESSAGE.READ) {
              slug = true;
            }
          });
        this.hasUnReadMessage = slug;
      })
    );
  }

  @action updateMessage(message, id) {
    return agent.Common.updateMessage(message, id).then(action(res => {}));
  }

  @action showUserNotice(id, title) {
    this.userNotice = true;
    this.joinGameTitle = title;
    this.joinGameId = id;
  }

  @action closeUserNotice() {
    this.userNotice = false;
  }

  @action showUserWorkNotice(id, title) {
    this.userWorkNotice = true;
    this.joinGameTitle = title;
    this.joinGameId = id;
  }

  @action closeUserWorkNotice() {
    this.userWorkNotice = false;
  }

  @action showJoinOrCreateModal() {
    this.joinOrCreateModal = true;
  }

  @action closeJoinOrCreateModal() {
    this.joinOrCreateModal = false;
  }

  @action logout(lang) {
    agent.Auth.logout().then(res => {
      window.location.href = $util.getRMHomeUrl(lang);
    });
  }

  @action checkUerWork(workInfos) {
    if (!workInfos || !workInfos.length) {
      return false;
    }
    for (let i = 0; i < workInfos.length; i++) {
      if (
        !workInfos[i] ||
        !workInfos[i].unit_type ||
        !workInfos[i].company_name ||
        !workInfos[i].department
      ) {
        return false;
      }
    }
    return true;
  }

  @action checkUer(user) {
    if (!user) {
      return false;
    }
    let oldUser = true;
    const neededInfo = [
      "nickname",
      "gender",
      "country",
      "birthday",
      "phone_number",
      "contact_phone",
      "contact_name",
      "contact_email",
      "nickname_en"
    ];
    // 缺个人信息
    for (let item of neededInfo) {
      if (item !== "contact_email") {
        if (!user[item]) {
          // 老用户除email外的必填项肯定都是有值的 只要有一项没填就是新用户
          oldUser = false;
        }
      }
      this.oldUser = oldUser;
      if (!user[item] && !oldUser) {
        return false;
      }
    }
    return true;
  }
}

export default new AuthStore();



// WEBPACK FOOTER //
// ./src/stores/authStore.js